// detectInAppBrowser.ts
export type InAppBrowserApp =
    | 'instagram'
    | 'facebook'
    | 'tiktok'
    | 'twitter'
    | 'linkedin'
    | 'snapchat'
    | 'reddit'
    | null;

export function detectInAppBrowser(): InAppBrowserApp {
    const ua =
        (typeof navigator !== 'undefined' &&
            (navigator.userAgent || navigator.vendor || (window as any).opera)) ||
        '';
    const uaLower = ua.toLowerCase();

    if (uaLower.includes('instagram')) return 'instagram';
    if (uaLower.includes('fbav') || uaLower.includes('fban') || uaLower.includes('messenger'))
        return 'facebook';
    if (uaLower.includes('tiktok')) return 'tiktok';
    if (uaLower.includes('twitter')) return 'twitter';
    if (uaLower.includes('linkedin')) return 'linkedin';
    if (uaLower.includes('snapchat')) return 'snapchat';
    if (uaLower.includes('reddit')) return 'reddit';

    return null;
}
